module.exports = __webpack_public_path__ + "img/spur_gear.prt.1309377d.jpg";